import { TMedecin } from "../types/medecin";
import { appRequest } from "./services";

export const listAllMedecins = async (user_uid: string) => {
    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        url: `medecins?fields[0]=id&fields[1]=nom&fields[2]=prenom&fields[3]=uid&populate=*&filters[user_uid][$eq]=${user_uid}&pagination[pageSize]=100`,
    });

    return currentRequest.data.data.map((item) => ({
        ...item,
        id: item.id,
        photo: {
            id: item.photo?.id,
            filename: item.photo?.name,
            url: item.photo?.url,
        },
    }));
};

export const listMedecinsByName = async (keyword: string) => {
    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        data: {
            loading: false,
        },
        url: `medecins?fields[0]=id&fields[1]=nom&fields[2]=prenom&fields[3]=uid&populate=*&filters[$or][0][nom][$contains]=${keyword}&filters[$or][1][prenom][$contains]=${keyword}&filters[$or][2][keyword][$contains]=${keyword}`,
    });

    return currentRequest.data.data.map((item) => ({
        ...item,
        id: item.id,
        photo: item.photo
            ? {
                  id: item.photo.id,
                  filename: item.photo.name,
                  url: item.photo.url,
              }
            : undefined,
    }));
};

export const createMedecin = async (data: any) => {
    const currentRequest = await appRequest<{
        data: TMedecin;
    }>({
        url: "medecins?populate=*",
        method: "POST",
        data: { data },
    });

    return currentRequest.data;
};

export const updateMedecin = async (data: any) => {
    const currentRequest = await appRequest<{
        data: TMedecin;
    }>({
        url: `medecins/${data.id}?populate=*`,
        method: "PUT",
        data: { data },
    });

    return currentRequest.data;
};

export const getMedecin = async (uid: string) => {
    const currentRequest = await appRequest<{
        data: Array<any>;
    }>({
        url: `medecins?populate=*&filters[uid][$eq]=${uid}`,
    });

    return currentRequest.data.data.map((item) => {
        return {
            id: item.id,
            uid: item.uid,
            nom: item.nom,
            prenom: item.prenom,
            civilite: item.civilite,
            profession: item.profession,
            keyword: item.keyword,
            photo: {
                id: item.photo?.id,
                filename: item.photo?.name,
                url: item.photo?.url,
            },
        } as TMedecin;
    });
};
